import { render } from "./RequestJobResolver.vue?vue&type=template&id=52a28633"
import script from "./RequestJobResolver.vue?vue&type=script&lang=js"
export * from "./RequestJobResolver.vue?vue&type=script&lang=js"

import "./RequestJobResolver.vue?vue&type=style&index=0&id=52a28633&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__